import { type ProductVariantRequestWithoutPagination as SchemaProductVariantRequestWithoutPagination } from '../schemas/ProductVariantRequestWithoutPagination';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Products
 */
export const GetProductVariantsCountContentType = 'application/json' as const;
export type GetProductVariantsCountRequest = SchemaProductVariantRequestWithoutPagination;
export type GetProductVariantsCountResponses = {
    /**
     * @description Successful retrieval of data
     */
    '200': {
        'application/json': number;
    };
};
export type GetProductVariantsCountResponseSuccess = GetProductVariantsCountResponses['200']['application/json'];
export type GetProductVariantsCountSearchParams = undefined;
export type GetProductVariantsCountPathParameters = undefined;
export const GetProductVariantsCountUrl = '/variants/count' as const;
export const GetProductVariantsCountMethod = 'POST' as const;
export const getGetProductVariantsCountUrl = (_params?: GetProductVariantsCountPathParameters) =>
    GetProductVariantsCountUrl;
